module.exports = __webpack_public_path__ + "static/media/srpt.c18da23f.png";